namespace Matrix.Rebalancer {
    export interface SummaryViewColumnRow {
        ViewCode?: string;
        FieldName?: string;
        Area?: string;
        AreaIndex?: number;
        Header?: string;
        DataFieldName?: string;
        Expression?: string;
        DataType?: string;
        SummaryType?: string;
        SummaryDisplayType?: string;
        FormatString?: string;
        SortFieldName?: string;
        SortSummaryType?: string;
        ShowTotals?: boolean;
        ShowGrandTotal?: boolean;
        Visible?: boolean;
        ActionTemplate?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        ViewCodeName?: string;
        ViewCodeRowId?: number;
    }

    export namespace SummaryViewColumnRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'ViewCode';
        export const localTextPrefix = 'Rebalancer.SummaryViewColumn';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            ViewCode = "ViewCode",
            FieldName = "FieldName",
            Area = "Area",
            AreaIndex = "AreaIndex",
            Header = "Header",
            DataFieldName = "DataFieldName",
            Expression = "Expression",
            DataType = "DataType",
            SummaryType = "SummaryType",
            SummaryDisplayType = "SummaryDisplayType",
            FormatString = "FormatString",
            SortFieldName = "SortFieldName",
            SortSummaryType = "SortSummaryType",
            ShowTotals = "ShowTotals",
            ShowGrandTotal = "ShowGrandTotal",
            Visible = "Visible",
            ActionTemplate = "ActionTemplate",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            ViewCodeName = "ViewCodeName",
            ViewCodeRowId = "ViewCodeRowId"
        }
    }
}
